












































































































































































































































































































































































































import { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import { Component } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import BIMixins from "@/mixins/BIMixins";
import NumberTmpl from "@/ui-component/number.vue";
import ErrorMixin from "@/mixins/errorMixins";
import EcartBOFOMixin from "@/mixins/EcartBOFOMixins";

@Component({
    components: {
        NumberTmpl
    }
})
export default class ValidBi extends mixins(MyMixin, BIMixins, ErrorMixin, EcartBOFOMixin) {
    public search = "";
    public headers = [
          {
            text: "id",
            align: "start",
            sortable: true,
            value: "bkNumber",
          },
          { text: "nom", value: "nomRestaurant" },
          { text: "Ca HT (€)", value: "caHT" },
          { text: "Ca TTC (€)", value: "caTTC" },
          { text: "tickets", value: "ticket" },
          { text: "repas employés", value: "nbRepasEmploye" },
          { text: "Remises (€)", value: "remises" },
        ];
    public recus: any;
    public showSiteDetails = false;
    public selectedSite: any;
    public datePick: any = new Date().toISOString().substr(0, 10);
    public site: string = this.sites[0].restaurantId;
    public tickets = new Array();
    public bons = new Array();
    public loadData = false;
    public clotures: any;
    public showPay = false;
    public showProfit = false;
    public montantRecus = { ttc: 0,
                            ht: 0,
                            reel: 0};
    public anomalies = 0;
    public isTicket = false;
    public isAllSites = false;
    public showCaisses = false;
    public showCoffres = false;
    public showVA = false;
    public listRestaurants: any;
    public comptagesCaisse = new Array();
    public comptageCoffre = new Array();
    public prixLines = {discountTVA: 0, discountTTC: 0};

     public showEcartBoFo = false;
    public showEcartSynth = false;
    public showRecu = false;
    public validated = false;

    public reinit() {
        this.showEcartBoFo = false;
        this.saucesOffertes = {montant: 0, qte: 0};
        this.discounts = {montant: 0, qte: 0, details: {} };
        this.annulations = {nbr: 0, montant: 0};
        this.annulationsDetails = new Array();
        this.commandesOuvertes = {nbr: 0, montant: 0, automatiques: 0, autoNbr : 0 };
        this.montantCommandesOuvertes = {ttc: 0, ht: 0};
        this.sommeLines = {montant: 0, nbr: 0, montantNetTva: 0, montantNetHT: 0, montantNetTTC: 0};
        this.modeEcole = {montantTTC: 0, montantHT: 0, nbr: 0};
        this.venteAnnexe = new Array();
        this.montantVA = 0;
        this.montantRecus = { ttc: 0,
                                ht: 0,
                                reel: 0};
        this.montantTickets = {ht: 0, ttc: 0, payByFamille: {}, pasNet: 0, nbr : 0};
        this.anomalies = 0;
        this.corrections = { sommetout: 0,
                            automatiques: 0,
                            autres: 0,
                            qualifier: 0,
                            montantTotal : 0,
                            nbr: 0,
                            correctionWithParent: 0,
                            };
        this.correctionsParNature = {KIOSK: 0, BEFORE_KITCHEN_SCREEN: 0, AFTER_ORDER_SUB_TOTAL: 0};
        this.correctionsCommandes = {KIOSK: 0, BEFORE_KITCHEN_SCREEN: 0, AFTER_ORDER_SUB_TOTAL: 0};
        this.correctionsTotales = {};
        this.prixLines = {discountTVA: 0, discountTTC: 0};

        const ethis = this;
        Object.keys(this.correctionsParProfit).map((key: any, index: any ) => {
            ethis.correctionsParProfit[key] = 0;
        });
        Object.keys(this.caParProfit).map((key: any, index: any ) => {
            ethis.caParProfit[key] = 0;
        });
        Object.keys(this.caParProfitHT).map((key: any, index: any ) => {
            ethis.caParProfitHT[key] = 0;
         });

        this.deliveryParType = {};
    }

    public getName(site: any) {
        return site.restaurantId + " - " + site.libelle;
    }

    public siteFilter(item: any, txt: string, itemTxt: any) {
        txt = txt.toUpperCase();
        return item.restaurantId.toString().includes(txt) || item.libelle.includes(txt);
        // return this.sites;
    }

    public showDetailsSite(site: any) {
        // console.log(site);
        this.selectedSite = site;
        this.showSiteDetails = true;
    }
    /**
     * analyses de l'export de tous les sites sur une journée donnée
     */
    public getAllSites() {
        this.isTicket = false;
        this.loadData = true;
        const url = "syntheserestau/exportHTTP?jsonFormat=true&dateDebut=" + this.datePick + "&dateFin=" + this.datePick;
        axios.get(url).then((response: any) => {
            this.isAllSites = true;
            console.log(response);
            this.listRestaurants = response.data.listRestaurants[0].listRestaurants;
            // console.log(this.listRestaurants);
            this.listRestaurants.map((site: any) => {
                site.caTTC = 0;
                site.caHT = 0;
                site.ticket = 0;
                site.remises = 0;
                site.nbRemises = 0;
                site.repasEmploye = 0;
                site.nbRepasEmploye = 0;
                site.nbAnnulations = 0;
                site.canalVente.map((canal: any) => {
                    site.caTTC += canal.caNetTtc;
                    site.caHT += canal.caNetHt;
                    site.ticket += canal.nbTickets;
                    site.remises += canal.discount;
                    site.repasEmploye += canal.montantBonRepas;
                    site.nbRepasEmploye += canal.nbBonRepas;
                    site.nbRemises += canal.nbDiscount;
                    site.nbAnnulations += canal.nbTicketsAnnule;
                });
            });
            this.loadData = false;
            this.analyseAllSites(this.site, this.listRestaurants);
        });
    }
    /**
     * methode de récuperation des tickets sur le serveur
     */
    public getTickets() {
        this.isAllSites = false;
        this.reinit();
        this.loadData = true;
        console.log(this.site);
        const url = "bi/exportHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            // console.log(response);
            this.isTicket = true;
            this.tickets = response.data.listTicket;
            this.clotures = response.data.clotures;
            // console.log(this.tickets[0]);

            this.calculatePayments(this.tickets);

            for (const ticket of this.tickets) {
                if (ticket.trainingMode !== null && !ticket.trainingMode) {
                this.analyseTickets(ticket);
                } else {
                    console.log(ticket);
                }

            }

            this.correctionsTotales.APRES = this.correctionsParNature.AFTER_ORDER_SUB_TOTAL + this.correctionsCommandes.AFTER_ORDER_SUB_TOTAL;
            this.correctionsTotales.AVANT = this.correctionsParNature.BEFORE_KITCHEN_SCREEN + this.correctionsCommandes.BEFORE_KITCHEN_SCREEN;
            this.correctionsTotales.KIOSK = this.correctionsParNature.KIOSK + this.correctionsCommandes.KIOSK;
            this.correctionsTotales.DELIVERY = this.correctionsParNature["HOME DELIVERY"];
            this.correctionsTotales.CC = this.correctionsParProfit["CLICK AND COLLECT"];

            console.log("----------- CA (montant entete) ------------- ");
            console.log("montant", this.montantTickets);
            console.log("profits", this.caParProfit);
            console.log("profits HT", this.caParProfitHT);
            console.log("----------- CA (montant lignes) ------------- ");
            console.log("somme tickets ", this.sommeLines);

            console.log("----------- Vente Annexe ------------- ");
            console.log("ventes Annexe", this.montantVA,  this.venteAnnexe);

            console.log("----------- CORRECTIONS ------------- ");
            console.log("corrections commandes", this.correctionsCommandes);
            console.log("corrections tickets", this.correctionsParNature);
            console.log("corections totales ", this.correctionsTotales);
            console.log("corections par profit ", this.correctionsParProfit);
            console.log("corections autres infos", this.corrections);

            console.log("----------- DELIVERY ------------- ");
            console.log("delivery par type", this.deliveryParType);
            console.log("----------- ANNULATIONS ------------- ");
            console.log("annulations", this.annulations);
            console.log("annulations détails ", this.annulationsDetails);
            console.log("----------- COMMANDES OUVERTES ------------- ");
            console.log("lignes commandes", this.commandesOuvertes);
            console.log("entete ", this.montantCommandesOuvertes);

            console.log("----------- Remises ------------- ");
            console.log("remises", this.discounts);
            console.log("sauces offertes", this.saucesOffertes);

            console.log("-------- LIGNES --------");
            console.log(this.prixLines);

            console.log("-------- ECOLE --------");
            console.log(this.modeEcole);

            this.loadData = false;
        },
        (error) => {
            console.log(error);
            this.setErrorFromTxt(error.toString());
            this.loadData = false;
        });

    }

    public getRecus() {
        this.isAllSites = false;
        this.loadData = true;
        const url = "bi/exportSAPHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            console.log(response.data);
            this.loadData = false;
            this.recus = response.data;
            this.analyseRecus(this.recus);
            this.showRecu = true;
            this.isTicket = false;
        });
    }

    public ecartBoFo() {
        this.loadData = true;
        this.showEcartBoFo = true;
        this.showEcartSynth = false;
        let tickets;
        const url = "bi/exportHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            console.log(response);
            tickets = response.data.listTicket;
            this.analyseTicketsFO(tickets);
            this.getRecus();
            this.validated = (this.recusData.montantRecus.toFixed(2) === this.montantTicketsBO.ttc.toFixed(2));
            console.log(this.validated);

        });
    }

    public ecartSynthTicket() {
        this.loadData = true;
        this.showEcartSynth = true;
        this.showEcartBoFo = false;
        let tickets;
        this.getAllSites();
        if (this.tickets.length <= 0 ) {
            const url = "bi/exportHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
            axios.get(url).then((response: any) => {
                console.log(response);
                tickets = response.data.listTicket;
                this.analyseTicketsFO(tickets);
                console.log(this.validated);

            });
        }
    }

    public getComptageCaisse() {
        this.isAllSites = false;
        this.showCaisses = true;
        // this.reinit();
        this.loadData = true;
        console.log(this.site);
        this.comptagesCaisse = new Array();
        const url = "bi/exportCashCountingsHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            console.log(response.data);
            let horodatage = 0;
            let cashcount: any;
            response.data.cashCountings.map((count: any) => {
                // console.log(count.dateEndSession, count.dateStartSession);
                if (count.dateEndSession !== horodatage) {
                    if (horodatage !== 0) {
                        this.comptagesCaisse.push(cashcount);
                    }
                    horodatage = count.dateEndSession;
                    cashcount = {
                        dateEndSession: count.dateEndSession,
                        dateStartSession: count.dateStartSession,
                        dateFiscale: count.dateFiscale,
                        responsable: count.responsable,
                        operator: count.operator,
                        dateHoroCashCounting: count.dateHoroCashCounting,
                        dateFirstTicket: count.dateFirstTicket,
                        dateLastTicket: count.dateLastTicket,
                        workStation: count.workStation,
                        reglements: [],
                        montantTheo: 0,
                        montantReel: 0,
                    };
                }

                const isRegl = count.amountType.split("[").length - 1;
                const rgle = {libelle: count.amountType, theo: count.amountThe, reel: count.amount, isRegl: isRegl > 1 };
                if ( isRegl > 1) {
                    cashcount.montantTheo += count.amountThe;
                    cashcount.montantReel += count.amount;
                }
                cashcount.reglements.push(rgle);
            });
            this.comptagesCaisse.push(cashcount);
            console.log(this.comptagesCaisse);
            this.loadData = false;
        });

    }

    public getComptageCoffre() {
        this.isAllSites = false;
        this.showCoffres = true;
        this.isTicket = false;
        this.showCaisses = false;
        this.loadData = true;
        console.log(this.site);
        this.comptageCoffre = new Array();
        const url = "bi/exportSafeCountingsHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            // console.log(response.data);
            let horodatage = 0;
            let cashcount: any;
            const safes = response.data.safeCountings.sort((u1: any, u2: any) =>
                (u1.dateHoroSafeCounting < u2.dateHoroSafeCounting ? -1 : 1)
            );
            console.log(safes);
            safes.map((count: any) => {
                const dateCount = new Date(count.dateHoroSafeCounting).getTime();
                // console.log(dateCount, horodatage, dateCount - horodatage, count.payment);

                if (horodatage - 2000 >= dateCount || horodatage + 2000 <= dateCount   ) {
                    // console.log("hop j'ajoute et horodatage: " + horodatage);
                    if (horodatage !== 0 ) {
                        this.comptageCoffre.push(cashcount);
                    }
                    horodatage = new Date(count.dateHoroSafeCounting).getTime();
                    cashcount = {
                        responsable: count.responsable,
                        operator: count.operator,
                        dateHoroSafeCounting: count.dateHoroSafeCounting,
                        coffres: [],
                        montantTheo: 0,
                        montantReel: 0,
                    };
                }
                const rgle = {libelle: count.payment, theo: count.totalAmounttheorique, reel: count.totalAmount, horo: count.dateHoroSafeCounting};
                cashcount.montantTheo += count.totalAmounttheorique;
                cashcount.montantReel += count.totalAmount;
                cashcount.coffres.push(rgle);
                this.loadData = false;
            });
            // console.log(cashcount);
            // console.log(this.comptageCoffre.length);
            this.comptageCoffre.push(cashcount);
            console.log(this.comptageCoffre);
            this.loadData = false;
        });

    }

    public getPrelevements() {
        this.isAllSites = false;
        // this.reinit();
        this.loadData = true;
        console.log(this.site);
        const url = "bi/exportSkimsHTTP?jsonFormat=true&dateFiscale=" + this.datePick + "&restaurantId=" + this.site;
        axios.get(url).then((response: any) => {
            console.log(response.data);
            this.loadData = false;

        });
    }

  public validateTicketRecus() {
    //   var validated = (montantRecus.toFixed(2) === montantTickets.toFixed(2));
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }
  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
